import styled from 'styled-components';

import InfiniteAutocomplete from 'components/InfiniteAutocomplete';

export const StyledAutocomplete = styled(InfiniteAutocomplete)`
  appearance: none;
  background-color: white;
  color: ${({ theme }) => theme.palette.primary.dark};

  .MuiAutocomplete-inputRoot {
    padding-top: 0px;
    padding-bottom: 0px;
    font-size: 14px;
    font-family: Roboto, sans-serif;
  }

  .MuiAutocomplete-option {
    font-size: 14px;
    font-family: Roboto, sans-serif;
  }
` as typeof InfiniteAutocomplete;

export const StyledOption = styled.li`
  font-size: 14px;
  font-family: Roboto, sans-serif;
  min-height: 24px !important;
`;
